import Axios from 'axios';
Axios.interceptors.request.use(config => {
    const tokenMeta = document.head.querySelector('meta[name="csrfToken"]');
    if (tokenMeta) {
        config.headers["Csrf-Token"] = tokenMeta.getAttribute('content');
    }
    return config;
});
async function getToken(card, storeId) {
    const { cardno, cvc, expiremonth, expireyear, holdername } = card;
    const request = {
        cardno,
        cvc,
        expiremonth,
        expireyear,
        holdername,
        storeId,
    };
    return Axios.post('/api/upc/transaction/token', request);
}
async function retrieveToken(storeId, tokenId) {
    return Axios.get(`/api/upc/transaction/token/${storeId}/${tokenId}`);
}
export default { getToken, retrieveToken };
